module.exports = __webpack_public_path__ + "static/media/twitter-icon-hover-2.7c64b2b9.svg";